import React, { useRef, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from '@fullcalendar/core/locales/es';

/**
 * Wrapper de FullCalendar
 * props:
 * - events: array de eventos
 * - onEventDrop({event})
 * - onEventResize({event})
 * - initialView: 'dayGridMonth' | 'timeGridWeek' | 'timeGridDay' | 'listWeek'
 * - onViewChange(viewName)
 */
export default function CalendarFC({
  events,
  onEventDrop,
  onEventResize,
  initialView = 'dayGridMonth',
  onViewChange,
  version,
  eventsSource,
  initialDate,
}) {
  const calendarRef = useRef(null);

  useEffect(() => {
    // asegurar que el calendario re-renderiza con el tema actual
  }, []);

  useEffect(() => {
    if (calendarRef.current) {
      const api = calendarRef.current.getApi();
      if (api?.refetchEvents) api.refetchEvents();
    }
  }, [version]);

  return (
    <div className="agenda-calendar">
      <FullCalendar
        ref={calendarRef}
        plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
        initialView={initialView}
        initialDate={initialDate}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek',
        }}
        buttonText={{ today: 'Hoy', month: 'Mes', week: 'Semana', day: 'Día', list: 'Agenda' }}
        locale={esLocale}
        firstDay={1}
        slotMinTime="08:00:00"
        slotMaxTime="23:00:00"
        slotLabelFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
        weekNumbers={false}
        navLinks={true}
        editable={true}
        droppable={true}
        eventStartEditable={true}
        eventDurationEditable={true}
        eventAllow={(dropInfo, draggedEvent) => {
          // Solo permitir editar eventos únicos
          return draggedEvent?.extendedProps?.kind === 'evento';
        }}
        events={eventsSource || events}
        eventDidMount={(arg) => {
          if (arg.event.classNames?.includes('event-conflict')) {
            arg.el.setAttribute('title', `Conflicto con ${arg.event.title}`);
          }
        }}
        eventDrop={(info) => onEventDrop && onEventDrop(info)}
        eventResize={(info) => onEventResize && onEventResize(info)}
        datesSet={(arg) => {
          onViewChange && onViewChange(arg.view.type);
          try {
            const prefs = { view: arg.view.type, dateISO: arg.view.currentStart?.toISOString?.() };
            localStorage.setItem('agenda@prefs', JSON.stringify(prefs));
          } catch {}
        }}
        dayMaxEvents={true}
        height="auto"
      />
    </div>
  );
}


